<template>
  <b-form-group
    label="Sıralama"
    label-for="ordering"
  >
    <validation-provider
      #default="{ errors }"
      name="Sıralama"
      rules="required"
    >
      <cleave
        id="ordering"
        v-model="dataItem.ordering"
        class="form-control"
        :raw="true"
        :options="options.ordering"
        placeholder="Sıralama"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
// eslint-disable-next-line no-unused-vars
import { required } from '@validations'
import Cleave from 'vue-cleave-component'

export default {
  name: 'Ordering',
  components: {
    Cleave,
    BFormGroup,
    ValidationProvider,
  },
  data() {
    return {
      required,
      options: {
        ordering: {
          numeral: true,
        },
      },
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['projectStatuses/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>

<style scoped>

</style>
